import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WHeroImageCCD: IClientComponentDefinition = {
  name: 'WHeroImage',
  load: () => import(/* webpackChunkName: 'WHeroImage' */ './w-hero-image'),
}
